import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { ReactComponent as CloseIcon } from "../../../assets/icons/quitModal.svg";
import { ReactComponent as Warning } from "../../../assets/icons/warning.svg";
import StyledModal from "./StyledModal";

const QuitModal = ({
  quitModalIsOpen,
  closeModalQuit,
  quitModal,
  description,
}) => {
  let customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "37%",
      borderRadius: "30px",
      boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.2)",
    },
  };

  const mediaMatch = window.matchMedia("(max-width: 850px)");
  mediaMatch.matches === true
    ? (customStyles.content = {
      ...customStyles.content,
      width: "70%",
    })
    : (customStyles.content = {
      ...customStyles.content,
      width: "37%",
    });

  return (
    <StyledModal>
      <Modal
        isOpen={quitModalIsOpen}
        onRequestClose={closeModalQuit}
        style={customStyles}
        contentLabel="Quit Modal"
        overlayClassName="overlay-modal"
        shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
        data={{ testid: "quit-modal" }}
      >
        <div className="wrapper-modal" data-testid="quit-modal-content">
          <div className="image" data-testid="quit-modal-warning-icon">
            <Warning />
          </div>
          <div
            className="orient main-text"
            data-testid="quit-modal-title"
          >
            Are you sure you want to quit?
          </div>
          <div
            className="second-text"
            data-testid="quit-modal-description"
          >
            {description}
          </div>
        </div>
        <div className="wrapper-buttons" data-testid="quit-modal-actions">
          <button
            className="cancel mr-6 flex items-center gap-1"
            onClick={quitModal}
            data-testid="quit-modal-confirm"
          >
            Quit <CloseIcon />
          </button>
          <button
            className="green-button"
            onClick={closeModalQuit}
            data-testid="quit-modal-cancel"
          >
            Stay
          </button>
        </div>
      </Modal>
    </StyledModal>
  );
};

QuitModal.propTypes = {
  quitModalIsOpen: PropTypes.bool,
  closeModalQuit: PropTypes.func,
  quitModal: PropTypes.func,
  description: PropTypes.string,
};
export default QuitModal;
